import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home2",
  "use": "icon-home2-usage",
  "viewBox": "0 0 127 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 127 128\" id=\"icon-home2\">\n  <path fill-rule=\"evenodd\" d=\"M0,54.86h54.8v18.28h-18.27v54.86h-18.26v-54.86h-18.27zM127.86,18.29h-35.93v109.71h-19.47v-109.71h-35.93v-18.29h91.33z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol